export const ADD_GADGET_BUTTON = 'button' as const;
export const ADD_GADGET_LINK = 'link' as const;
